import { vsprintf } from "sprintf-js";
import { rootStore } from "../../../redux/store";
import { setErrorState } from "../../../redux/error_banner/actions";
import {
    API_ENDPOINT,
    API_VERSION,
    clientErrorMessages,
    httpMethods,
} from "../../../constants";
import {
    INSTITUTION_REGEX_PATTERN,
    NAME_INSTITUTION_REGEX_PATTERN,
} from "./constants";
import { trackingEventNames } from "../../../helpers/pendo_constants";
import { addPendoTracking } from "../../../helpers/helpers";

export async function createNote(input) {
    const url = vsprintf("%s/api/%s/tplan_store/patient/%s/plan/%s/note", [
        API_ENDPOINT,
        API_VERSION,
        input.patientUuid,
        input.planUuid,
    ]);

    try {
        const resp = await fetch(url, {
            method: httpMethods.POST,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${input.token}`,
            },
            body: JSON.stringify({
                userUuid: input.userUuid,
                step: input.step,
                content: input.content,
            }),
            mode: "cors",
        });

        return resp.json();
    } catch {
        rootStore.dispatch(
            setErrorState(
                true,
                trackingEventNames.CREATE_NOTE,
                input.planUuid,
                clientErrorMessages.FAILED_TO_CREATE_PATIENT_NOTES
            )
        );
        return null;
    }
}

export async function getAllNotes(input) {
    const url = vsprintf("%s/api/%s/tplan_store/patient/%s/plan/%s/note", [
        API_ENDPOINT,
        API_VERSION,
        input.patientUuid,
        input.planUuid,
    ]);

    try {
        const resp = await fetch(url, {
            method: httpMethods.GET,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${input.token}`,
            },
            mode: "cors",
        });

        return resp.json();
    } catch {
        rootStore.dispatch(
            setErrorState(
                true,
                trackingEventNames.GET_NOTES,
                input.planUuid,
                clientErrorMessages.FAILED_TO_FETCH_PATIENT_NOTES
            )
        );
        return null;
    }
}

export async function updateClinician(input) {
    const url = vsprintf(
        "%s/api/%s/tplan_store/patient/%s/plan/%s/primary_physician",
        [API_ENDPOINT, API_VERSION, input.patientUUID, input.planUUID]
    );

    try {
        const response = await fetch(url, {
            method: httpMethods.PUT,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${input.token}`,
            },
            body: JSON.stringify({
                AssignerUserUUID: input.AssignerUserUUID,
                AssigneeUserUUID: input.AssigneeUserUUID,
            }),
            mode: "cors",
        });

        return response.json();
    } catch {
        addPendoTracking(
            trackingEventNames.UPDATE_CLINICIAN,
            input.planUUID,
            clientErrorMessages.FAILED_TO_UPDATE_CLINICIAN
        );
        rootStore.dispatch(
            setErrorState(
                true,
                trackingEventNames.UPDATE_CLINICIAN,
                input.planUUID,
                clientErrorMessages.FAILED_TO_UPDATE_CLINICIAN
            )
        );
    }
}

export async function addPlanFlag(input) {
    const url = vsprintf("%s/api/%s/tplan_store/patient/%s/plan/%s/flag", [
        API_ENDPOINT,
        API_VERSION,
        input.patientUUID,
        input.planUUID,
    ]);

    try {
        const response = await fetch(url, {
            method: httpMethods.POST,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${input.token}`,
            },
            body: JSON.stringify({
                userUuid: input.userUuid,
                content: input.content,
            }),
            mode: "cors",
        });

        return response.json();
    } catch {
        rootStore.dispatch(
            setErrorState(
                true,
                trackingEventNames.ADD_PLAN_FLAG,
                input.planUUID,
                clientErrorMessages.FAILED_TO_UPDATE_PLAN_FLAG
            )
        );
    }
}

export function formatDate(timestamp) {
    const timestampDate = timestamp.substring(0, 10);
    const [year, month, day] = timestampDate.split("-");
    return `${month}/${day}/${year}`;
}

export function filterAvendaHelperAccounts(doctors, user) {
    // Check if the user's email matches either the name-institution or the institution pattern
    if (
        user?.email?.match(NAME_INSTITUTION_REGEX_PATTERN) ||
        user?.email?.match(INSTITUTION_REGEX_PATTERN)
    ) {
        return doctors; // Show all emails
    } else {
        // If the user's email does not match the patterns for broader access,
        // filter out any doctor whose email matches the name-institution pattern
        return doctors.filter(
            (doctor) =>
                // Include the doctor if their email does not match the name-institution pattern
                !doctor.email.match(NAME_INSTITUTION_REGEX_PATTERN)
        );
    }
}

export function filterAvendaHelperAccountsForAssignedClinician(doctors, user) {
    // Check if the user's email matches either the name-institution or the institution pattern
    if (user?.email?.match(INSTITUTION_REGEX_PATTERN)) {
        return doctors; // Show all emails
    } else {
        // If the user's email does not match the patterns for broader access,
        // filter out any doctor whose email matches the name-institution pattern
        return doctors.filter(
            (doctor) =>
                // Include the doctor if their email does not match the name-institution pattern
                !doctor.email.match(INSTITUTION_REGEX_PATTERN)
        );
    }
}
